import { render, staticRenderFns } from "./publishActivity.vue?vue&type=template&id=063e2df0&scoped=true"
import script from "./publishActivity.vue?vue&type=script&lang=js"
export * from "./publishActivity.vue?vue&type=script&lang=js"
import style0 from "./publishActivity.vue?vue&type=style&index=0&id=063e2df0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e2df0",
  null
  
)

export default component.exports